<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full tw-py-4">
            <h2 class="tw-font-bold">Merci pour votre inscription.</h2>
            <p class="tw-font-light">Vous serez recontacté par ENI dans les meilleurs délais pour finaliser votre demande</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    color: $white;

    h2 {
        font-size: 24px;
    }
}

</style>
